/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BillingDetailsObjectType,
    BillingDetailsObjectTypeFromJSON,
    BillingDetailsObjectTypeFromJSONTyped,
    BillingDetailsObjectTypeToJSON,
} from './BillingDetailsObjectType';
import {
    BillingProduct,
    BillingProductFromJSON,
    BillingProductFromJSONTyped,
    BillingProductToJSON,
} from './BillingProduct';
import {
    SubscriptionStatus,
    SubscriptionStatusFromJSON,
    SubscriptionStatusFromJSONTyped,
    SubscriptionStatusToJSON,
} from './SubscriptionStatus';

/**
 * 
 * @export
 * @interface BillingDetails
 */
export interface BillingDetails {
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    id: string;
    /**
     * 
     * @type {BillingDetailsObjectType}
     * @memberof BillingDetails
     */
    object: BillingDetailsObjectType;
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    program_id: string;
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillingDetails
     */
    has_payment_method: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BillingDetails
     */
    cancel_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BillingDetails
     */
    canceled?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BillingDetails
     */
    current_period_end?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BillingDetails
     */
    current_period_start?: Date;
    /**
     * 
     * @type {number}
     * @memberof BillingDetails
     */
    days_until_due?: number;
    /**
     * 
     * @type {Date}
     * @memberof BillingDetails
     */
    ended?: Date;
    /**
     * 
     * @type {Array<BillingProduct>}
     * @memberof BillingDetails
     */
    products: Array<BillingProduct>;
    /**
     * 
     * @type {Date}
     * @memberof BillingDetails
     */
    start_date?: Date;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof BillingDetails
     */
    status: SubscriptionStatus;
    /**
     * 
     * @type {Date}
     * @memberof BillingDetails
     */
    trial_end?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BillingDetails
     */
    trial_start?: Date;
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    timezone: string;
    /**
     * 
     * @type {Date}
     * @memberof BillingDetails
     */
    created: Date;
}

export function BillingDetailsFromJSON(json: any): BillingDetails {
    return BillingDetailsFromJSONTyped(json, false);
}

export function BillingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': BillingDetailsObjectTypeFromJSON(json['object']),
        'program_id': json['program_id'],
        'email': json['email'],
        'has_payment_method': json['has_payment_method'],
        'cancel_on': !exists(json, 'cancel_on') ? undefined : (new Date(json['cancel_on'])),
        'canceled': !exists(json, 'canceled') ? undefined : (new Date(json['canceled'])),
        'current_period_end': !exists(json, 'current_period_end') ? undefined : (new Date(json['current_period_end'])),
        'current_period_start': !exists(json, 'current_period_start') ? undefined : (new Date(json['current_period_start'])),
        'days_until_due': !exists(json, 'days_until_due') ? undefined : json['days_until_due'],
        'ended': !exists(json, 'ended') ? undefined : (new Date(json['ended'])),
        'products': ((json['products'] as Array<any>).map(BillingProductFromJSON)),
        'start_date': !exists(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'status': SubscriptionStatusFromJSON(json['status']),
        'trial_end': !exists(json, 'trial_end') ? undefined : (new Date(json['trial_end'])),
        'trial_start': !exists(json, 'trial_start') ? undefined : (new Date(json['trial_start'])),
        'timezone': json['timezone'],
        'created': (new Date(json['created'])),
    };
}

export function BillingDetailsToJSON(value?: BillingDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': BillingDetailsObjectTypeToJSON(value.object),
        'program_id': value.program_id,
        'email': value.email,
        'has_payment_method': value.has_payment_method,
        'cancel_on': value.cancel_on === undefined ? undefined : (value.cancel_on.toISOString()),
        'canceled': value.canceled === undefined ? undefined : (value.canceled.toISOString()),
        'current_period_end': value.current_period_end === undefined ? undefined : (value.current_period_end.toISOString()),
        'current_period_start': value.current_period_start === undefined ? undefined : (value.current_period_start.toISOString()),
        'days_until_due': value.days_until_due,
        'ended': value.ended === undefined ? undefined : (value.ended.toISOString()),
        'products': ((value.products as Array<any>).map(BillingProductToJSON)),
        'start_date': value.start_date === undefined ? undefined : (value.start_date.toISOString()),
        'status': SubscriptionStatusToJSON(value.status),
        'trial_end': value.trial_end === undefined ? undefined : (value.trial_end.toISOString()),
        'trial_start': value.trial_start === undefined ? undefined : (value.trial_start.toISOString()),
        'timezone': value.timezone,
        'created': (value.created.toISOString()),
    };
}

